// export default {
//   IS_DEV: true,
//   API_ENDPOINT: "https://4zsr8pty6a.execute-api.ap-east-1.amazonaws.com/dev", //"https://api-dev.makealive.com",
//   CHECKOUT_DOMAIN: "https://stream-dev.makealive.com",
//   GTM_ID: "GTM-TN6M7C5",
//   APPLE_SIGN_IN_CLIENT_ID: "www-dev.makealive.com",
//   APPLE_SIGN_IN_REDIRECT_URI: "https://www-dev.makealive.com",
//   FB_ID: "1414057529099185",
//   GOOGLE_ID:
//     "702669211442-9921ec0vihrgk6d5dbs34rvaa8kvmvut.apps.googleusercontent.com",
//   EMAIL_REGEX:
//     "^[a-zA-Z0-9!#$%&'*+=?^_`{|}~-]+(?:.[a-zA-Z0-9!#$%&'*+=?^_`{|}~-]+)*@(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?.)+[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?$",
//   FIRSTNAME_REGEX: "^[a-zA-Z\\s\\.'\\-]{2,30}$",
//   LASTNAME_REGEX: "^[a-zA-Z\\s\\.'\\-]{2,30}$",
//   PHONE_REGEX: "^\\+852[0-9]{8}$",
//   PASSWORD_REGEX: "^(?=.*[a-z])(?=.*[A-Z])(?=.*\\d)[[A-Za-z\\d@$!%*#?&]{8,30}$",
//   RECAPTCHA: "6LcxTHIfAAAAAFvLyYwI2c_CkH0chwCk41caDu7z",
//   CLIENT_ID: "c16f2bd94076e9cc39e51daa42407d95",
//   CLIENT_SECRET: "Zr4u7x!A%D*G-KaPdSgVkYp3s5v8y/B?",
// };

// STAGING
// export default {
//     IS_DEV: true,
//     API_ENDPOINT: "https://api-stg.makealive.com",
//     CHECKOUT_DOMAIN: "https://stream.makealive.com",
//     GTM_ID: "GTM-TN6M7C5",
//     APPLE_SIGN_IN_CLIENT_ID: "makealive.com",
//     APPLE_SIGN_IN_REDIRECT_URI: "https://www-stg.makealive.com",
//     FB_ID: '271024998512552',
//     GOOGLE_ID: '55545195307-5bnub9g1khl849vjtc2dk8nukc56ba91.apps.googleusercontent.com',
//     EMAIL_REGEX: "^[a-zA-Z0-9!#$%&'*+=?^_`{|}~-]+(?:\.[a-zA-Z0-9!#$%&'*+=?^_`{|}~-]+)*@(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?\.)+[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?$",
//     FIRSTNAME_REGEX: "^[a-zA-Z\\s\\.'\\-]{2,30}$",
//     LASTNAME_REGEX: "^[a-zA-Z\\s\\.'\\-]{2,30}$",
//     PHONE_REGEX: "^\\+852[0-9]{8}$",
//     PASSWORD_REGEX: "^(?=.*[a-z])(?=.*[A-Z])(?=.*\\d)[[A-Za-z\\d@$!%*#?&]{8,30}$",
//     RECAPTCHA: "6LchAe4gAAAAAHIK4ZZt0DL4Sx8bzUHL7tpXG5cN",
//     CLIENT_ID: "6c6fa27bac69aba82880672f9427daf9",
//     CLIENT_SECRET: "dSgVkYp3s6v9yaB&E)H@McQeThWmZq4t",
// }

// PROD
export default {
  IS_DEV: false,
  API_ENDPOINT: "https://api.makealive.com",
  CHECKOUT_DOMAIN: "https://stream.makealive.com",
  GTM_ID: "GTM-WW4FHK2",
  APPLE_SIGN_IN_CLIENT_ID: "makealive.com",
  APPLE_SIGN_IN_REDIRECT_URI: "https://www.makealive.com",
  FB_ID: "271024998512552",
  GOOGLE_ID:
    "55545195307-5bnub9g1khl849vjtc2dk8nukc56ba91.apps.googleusercontent.com",
  EMAIL_REGEX:
    "^[a-zA-Z0-9!#$%&'*+=?^_`{|}~-]+(?:.[a-zA-Z0-9!#$%&'*+=?^_`{|}~-]+)*@(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?.)+[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?$",
  FIRSTNAME_REGEX: "^[a-zA-Z\\s\\.'\\-]{2,30}$",
  LASTNAME_REGEX: "^[a-zA-Z\\s\\.'\\-]{2,30}$",
  PHONE_REGEX: "^\\+852[0-9]{8}$",
  PASSWORD_REGEX: "^(?=.*[a-z])(?=.*[A-Z])(?=.*\\d)[[A-Za-z\\d@$!%*#?&]{8,30}$",
  RECAPTCHA: "6LchAe4gAAAAAHIK4ZZt0DL4Sx8bzUHL7tpXG5cN",
  CLIENT_ID: "6c6fa27bac69aba82880672f9427daf9",
  CLIENT_SECRET: "dSgVkYp3s6v9yaB&E)H@McQeThWmZq4t",
};
